import { memo } from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeProvider';

const ThemeToggleButton = ({ variant = 'inline' }) => {
    const { isDarkMode, toggleTheme } = useTheme();

    const containerClass =
        variant === 'floating'
            ? 'fixed top-4 right-4 z-[1000]'
            : '';

    return (
        <div className={`${containerClass} flex items-center justify-center`}>
            <button
                onClick={toggleTheme}
                className={`relative flex h-8 w-16 items-center rounded-full p-1 transition-colors duration-300 ${isDarkMode ? 'bg-slate-700' : 'bg-gray-200'
                    }`}
                aria-label="Toggle theme"
            >
                <motion.div
                    layout
                    transition={{
                        type: 'spring',
                        stiffness: 500,
                        damping: 35,
                        mass: 0.8
                    }}
                    className={`flex h-6 w-6 items-center justify-center rounded-full shadow-md ${isDarkMode ? 'bg-slate-800 text-white' : 'bg-white text-gray-800'
                        }`}
                    animate={{
                        x: isDarkMode ? 32 : 0,
                    }}
                >
                    {isDarkMode ? <Moon size={14} /> : <Sun size={14} />}
                </motion.div>
            </button>
        </div>
    );
};

export default memo(ThemeToggleButton);

